module.exports = __webpack_public_path__ + "img/faceit.76faa79f.svg";